'use strict';

var basePage = require('./base-page.js');

module.exports = basePage;